module.exports = __webpack_public_path__ + "static/Manitoba-ea6f01f52288a7f7670ffd87183efb6d.png";